import { AnimatePresence, motion } from 'framer-motion';
import { useRealtime } from '@/stores/realtime';
import { useAuth } from '@/stores/auth';
import { Icon } from '@/components/ui/Icon';
import { realtime } from '@/realtime';

/** "Reconnecting…" top banner whenever the live connection drops. */
export function ConnectionBanner() {
  const status = useRealtime((s) => s.status);
  const authed = useAuth((s) => s.status === 'authed');
  const show = authed && (status === 'reconnecting' || status === 'offline');
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          className="fixed inset-x-0 top-0 z-[80] flex justify-center px-3 pt-[calc(env(safe-area-inset-top)+8px)]"
          role="status"
          data-testid="ws-banner"
        >
          <div className="flex items-center gap-2.5 rounded-full bg-primary py-2 pl-3 pr-2 text-sm font-medium text-ground shadow-lift">
            {status === 'offline' ? (
              <>
                <Icon name="wifi-off" size={18} />
                <span>You’re offline. Live updates are paused.</span>
                <button type="button" className="rounded-full bg-ground px-3 py-1 text-xs font-semibold text-fg" onClick={() => realtime.kick()}>
                  Retry
                </button>
              </>
            ) : (
              <>
                <span className="inline-flex h-2.5 w-2.5 rounded-full bg-yellow" aria-hidden />
                <span className="pr-2">Reconnecting…</span>
              </>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
